import { createContext } from 'react'
import { initialState, SignupState } from '.'
type ContextType = [SignupState, (_action: any) => any]
export const SignupContext = createContext<ContextType>([initialState, () => null])
